import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @Output() public game: EventEmitter<any> = new EventEmitter;
  @Output() public premios: EventEmitter<any> = new EventEmitter;
  @Output() public ganadores: EventEmitter<any> = new EventEmitter;
  @Output() public config: EventEmitter<any> = new EventEmitter;

  constructor() { }

  ngOnInit() { 
  }

  goToGame(){
    this.game.emit(true);
  }
  goToPremios(){
    this.premios.emit(true);
  }
  goToGanadores(){
    this.ganadores.emit(true);
  }
  goToConfig(){
    this.config.emit(true);
  }

}
